import PropTypes from 'prop-types';

function TextArea({
  label,
  rows,
  name,
  value,
  handleChange,
  style,
  disabled,
  mt,
}) {
  return (
    <div style={(mt, { width: '100%' })}>
      <span className="label" htmlFor={name}>
        {label}
      </span>
      {/* <br /> */}
      <textarea
        className="input_textArea"
        rows={`${rows}`}
        id={name}
        type="text"
        name={name}
        style={style}
        autoComplete="off"
        value={value}
        onChange={handleChange}
        disabled={disabled}
      />
    </div>
  );
}

export default TextArea;

TextArea.propTypes = {
  label: PropTypes.string.isRequired,
  rows: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
};
